<div id="upload-component" [ngStyle]="{'marginTop':( isDesktop$  | async) ? '220px' : '40px'}">
    <h1>
        <lucide-angular name="monitor-down" strokeWidth="2" size="44">q</lucide-angular>
        {{ 'nav.upload.title' | translate }}
    </h1>
    <p>{{ 'upload.hook' | translate }}</p>
    @if(isLoading$ | async){

    <div class="uploading-element">
        <ng-lottie [options]="options"></ng-lottie>
        <div class="progress-bar">
            <div class="progress"></div>
        </div>
        <!-- uploading (fake progress bar) ... -->
    </div>
    } @else {
    <form class="upload" [formGroup]="uploadForm" (ngSubmit)="onSubmit()">

        @if(previewUrl){
        <label class="label" for="title">
            {{ "common.title" | translate }}
            <input type="text" name="title" id="title" formControlName="title">
            @if(uploadForm.controls['title'].invalid && (uploadForm.controls['title'].dirty ||
            uploadForm.controls['title'].touched)){

            <p class="error">
                @if (uploadForm.controls['title'].errors?.['minlength']) {
                @let minLengthRequired = uploadForm.controls['title'].errors?.['minlength']?.requiredLength;
                minimum {{ minLengthRequired }} characters.
                }
                @else if (uploadForm.controls['title'].errors?.['maxlength']) {
                @let maxLengthRequired = uploadForm.controls['title'].errors?.['maxlength']?.requiredLength;
                maximum {{ maxLengthRequired }} characters.
                }
            </p>
            }
        </label>
        }

        @if(previewUrl === null ) {
        <label for="upload" class="input-video">
            <lucide-angular name="plus" size="44" strokeWidth="2" color="#EFF9F5"></lucide-angular>
            <input [multiple]="false" type="file" name="upload" id="upload" accept="video/*"
                (change)="onFileSelected($event)">
            <p>{{ 'upload.buttons.import' | translate }}</p>
        </label>

        <ul class="requierment-list">
            <li>{{ 'upload.requierment_list.1' | translate }}</li>
            <li>{{ 'upload.requierment_list.2' | translate }}</li>
        </ul>
        <ul class="advice-list">
            <p>{{ 'upload.advice_list.title' | translate }}</p>
            <li>- {{ 'upload.advice_list.1' | translate }}</li>
            <li>- {{ 'upload.advice_list.2' | translate }}</li>
        </ul>
        }
        @else {
        <div id="upload-player">
            <div class="remove-video" (click)="removeVideo()">
                <lucide-angular name="x" color="#1D1E2D"></lucide-angular>
            </div>
            <video #videoPlayer controls>
                <source [attr.src]="previewUrl" [attr.type]="uploadVideoFormat">
            </video>
        </div>
        <p>({{videoDuration || 0}} tokens)</p>
        }


        @if(previewUrl){
        <label class="label" for="context">
            {{ 'common.context' }}:
            <textarea rows="5" type="text" name="context" id="context" formControlName="context"
                placeholder="Une femme qui raconte l'histoire de son entreprise, du début jusqu'à son succés..."></textarea>
        </label>

        @if(languages.length > 0 && defaultOriginalLanguageId && defaultOutputLanguageId){
        <div id="lang-selection">

            <label class="select-label" for="language-from">{{ "common.from" | translate }}
                <select name="language-from" id="language-from" formControlName="languageFrom">
                    @for (lang of languages; track $index) {
                    <option [value]="lang.id">{{ 'languages.' + lang.name | translate }}</option>
                    }
                </select>
            </label>
            <lucide-icon name="arrowRight"></lucide-icon>

            <label class="select-label" for="language-to">{{ "common.to" | translate }}
                <select name="language-to" id="language-to" formControlName="languageTo">
                    @for (lang of languages; track $index) {
                    <option [value]="lang.id">{{ 'languages.' + lang.name | translate }}</option>
                    }
                </select>
            </label>

        </div>
        }
        <app-button type="submit" class="submit-btn" [disabled]="!uploadForm.valid">
            <lucide-angular name="languages" color="#92c1b0ff"></lucide-angular>{{ 'upload.buttons.translate' |
            translate }}</app-button>
        }
    </form>
    }
</div>